module.exports = __webpack_public_path__ + "static/media/background.20f5a109.png";